<template>
  <RouterView v-slot="{ Component }">
    <Transition name="fade-fast">
      <component :is="Component" />
    </Transition>
  </RouterView>
</template>

<script>
import { useLangRouter } from '@/extensions/langRouter'

export default {
  name: 'App',
  setup() {
    useLangRouter()
  },
  watch: {
    '$i18n.locale': {
      handler: function (to) {
        this.$beet.fetchCoreData(to)
      },
      immediate: true,
    },
  },
}
</script>
